export const ttdStates = [
  { name: 'Alabama', abbreviation: 'AL' },
  { name: 'Alaska', abbreviation: 'AK' },
  { name: 'Arkansas', abbreviation: 'AR' },
  { name: 'Arizona', abbreviation: 'AZ' },
  { name: 'California', abbreviation: 'CA' },
  { name: 'Colorado', abbreviation: 'CO' },
  { name: 'Connecticut', abbreviation: 'CT' },
  { name: 'Delaware', abbreviation: 'DE' },
  { name: 'Florida', abbreviation: 'FL' },
  { name: 'Georgia', abbreviation: 'GA' },
  { name: 'Hawaii', abbreviation: 'HI' },
  { name: 'Iowa', abbreviation: 'IA' },
  { name: 'Idaho', abbreviation: 'ID' },
  { name: 'Illinois', abbreviation: 'IL' },
  { name: 'Indiana', abbreviation: 'IN' },
  { name: 'Kansas', abbreviation: 'KS' },
  { name: 'Kentucky', abbreviation: 'KY' },
  { name: 'Louisiana', abbreviation: 'LA' },
  { name: 'Massachusetts', abbreviation: 'MA' },
  { name: 'Maryland', abbreviation: 'MD' },
  { name: 'Maine', abbreviation: 'ME' },
  { name: 'Michigan', abbreviation: 'MI' },
  { name: 'Minnesota', abbreviation: 'MN' },
  { name: 'Missouri', abbreviation: 'MO' },
  { name: 'Mississippi', abbreviation: 'MS' },
  { name: 'Montana', abbreviation: 'MT' },
  { name: 'NorthCarolina', abbreviation: 'NC' },
  { name: 'NorthDakota', abbreviation: 'ND' },
  { name: 'Nebraska', abbreviation: 'NE' },
  { name: 'NewHampshire', abbreviation: 'NH' },
  { name: 'NewJersey', abbreviation: 'NJ' },
  { name: 'NewMexico', abbreviation: 'NM' },
  { name: 'Nevada', abbreviation: 'NV' },
  { name: 'NewYork', abbreviation: 'NY' },
  { name: 'Ohio', abbreviation: 'OH' },
  { name: 'Oklahoma', abbreviation: 'OK' },
  { name: 'Oregon', abbreviation: 'OR' },
  { name: 'Pennsylvania', abbreviation: 'PA' },
  { name: 'RhodeIsland', abbreviation: 'RI' },
  { name: 'SouthCarolina', abbreviation: 'SC' },
  { name: 'SouthDakota', abbreviation: 'SD' },
  { name: 'Tennessee', abbreviation: 'TN' },
  { name: 'Texas', abbreviation: 'TX' },
  { name: 'Utah', abbreviation: 'UT' },
  { name: 'Virginia', abbreviation: 'VA' },
  { name: 'Vermont', abbreviation: 'VT' },
  { name: 'Wisconsin', abbreviation: 'WI' },
  { name: 'WestVirginia', abbreviation: 'WV' },
  { name: 'Wyoming', abbreviation: 'WY' },
  { name: 'WashingtonDC', abbreviation: 'DC' },
];
